import Common from '../common.js';

export default {
    downloadFile: function (storedFileId, async, successCallback, errorCallback) {
        var d = null;
        $.ajax({
            url: Application.getBasePath() + '/platform/api/file-storage/' + storedFileId + '/download',
            type: 'GET',
            //dataType: "json",
            async: async,
            //contentType: 'application/json',
            xhrFields: {withCredentials: true},
            success: function (data, textStatus) {
                d = data;
                if (successCallback != null) {
                    successCallback(data);
                }
            },
            error: function (jqXHR, data, textStatus) {
                var obj = jQuery.parseJSON(jqXHR.responseText);
                if (errorCallback != null) {
                    errorCallback(obj.message);
                }
            }
        });

        return d;
    },
    updateFile: function (storedFileId, selector, async, successCallback, errorCallback) {
        var postData = new FormData($(selector)[0]);

        $.ajax({
            url: Application.getBasePath() + '/platform/api/file-storage/' + storedFileId + '/update',
            type: 'POST',
            data: postData,
            xhr: function() {  // Custom XMLHttpRequest
                var myXhr = $.ajaxSettings.xhr();
                if(myXhr.upload){ // Check if upload property exists
                    //myXhr.upload.addEventListener('progress', null, false); // For handling the progress of the upload
                }
                return myXhr;
            },
            dataType: 'json',
            cache: false,
            contentType: false,
            processData: false,
            async: async,
            xhrFields: {withCredentials: true},
            success: function (data, textStatus) {
                if (successCallback != null) {
                    successCallback(data);
                }
            },
            error: function (jqXHR, data, textStatus) {
                var obj = jQuery.parseJSON(jqXHR.responseText);
                Common.showToast('error', 'Ошибка', obj.message);
                if (errorCallback != null) {
                    errorCallback(obj.message);
                }
            }
        });
    }
    ,
    updateAvatar: function (selector, async, successCallback, errorCallback) {
        var postData = new FormData($(selector)[0]);
        let result = null;

        $.ajax({
            url: Application.getBasePath() + '/api/profile/store-avatar',
            type: 'POST',
            data: postData,
            xhr: function() {  // Custom XMLHttpRequest
                var myXhr = $.ajaxSettings.xhr();
                if(myXhr.upload){ // Check if upload property exists
                    //myXhr.upload.addEventListener('progress', null, false); // For handling the progress of the upload
                }
                return myXhr;
            },
            dataType: 'json',
            cache: false,
            contentType: false,
            processData: false,
            async: async,
            xhrFields: {withCredentials: true},
            success: function (data, textStatus) {
                result = data;
                if (successCallback != null) {
                    successCallback(data);
                }
            },
            error: function (jqXHR, data, textStatus) {
                var obj = jQuery.parseJSON(jqXHR.responseText);
                Common.showToast('error', 'Ошибка', obj.message);
                if (errorCallback != null) {
                    errorCallback(obj.message);
                }
            }
        });

        return result;
    },
    getStoredFile: function (id, enrich) {
        var queryParams = '/' + id + '?';
        if (enrich != null) {
            queryParams += 'enrich=' + enrich;
        }

        var d = null;
        $.ajax({
            url: Application.getBasePath() + '/api/quiz/file' + queryParams,
            type: 'GET',
            dataType: "json",
            async: false,
            contentType: 'application/json',
            success: function (data, textStatus) {
                d = data;
            },
            error: function (jqXHR, data, textStatus) {
                var obj = jQuery.parseJSON(jqXHR.responseText);
            }
        });

        return d;
    },

    createStoredFile: function (model) {
        var result = null;

        $.ajax({
            url: Application.getBasePath() + '/platform/api/file-storage/save',
            type: 'POST',
            data: $.toJSON(model),
            dataType: "json",
            async: false,
            contentType: 'application/json',
            success: function (data, textStatus) {
                result = data.id;

                //Common.showToast('success', 'Успех', 'Изменения успешно сохранены');
            },
            error: function (jqXHR, data, textStatus) {
                console.log('catched!');

                var obj = jQuery.parseJSON(jqXHR.responseText);
                Common.showToast('error', 'Ошибка', obj.message);
            }
        });


        return result;
    },
};


// WEBPACK FOOTER //
// ./src/api/fileStorage.js